module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Sponsors","desc":"Thanks to the maintenance and sponsors of these companies or individuals, IX42 can maintain efficient and stable operations."},"zh":{"title":"赞助商","desc":"感谢以下提供赞助和维护的公司及个人，使得 IX42 得以长期高效且稳定地运行。"}}')
  delete Component.options._Ctor
}
